// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestId } from './Harvest';
import { harvestOperationId } from './HarvestOperation';
import { harvestProtocolKpiId } from './HarvestProtocolKpi';
import { harvestOperationTemplateKpiId } from './HarvestOperationTemplateKpi';
import { operatorId } from './Operator';
import { z } from 'zod';
export const harvestSessionKpiId = (z.number());
export const harvestSessionKpi = z.object({
    id: harvestSessionKpiId,
    harvest_id: harvestId,
    harvest_operation_id: harvestOperationId.nullable(),
    source_protocol_kpi_id: harvestProtocolKpiId.nullable(),
    source_template_kpi_id: harvestOperationTemplateKpiId.nullable(),
    copied_from_session_kpi_id: harvestSessionKpiId.nullable(),
    code: z.string().nullable(),
    name: z.string(),
    formula: z.string(),
    result_unit: z.string().nullable(),
    result_display_unit: z.string().nullable(),
    display_group: z.string().nullable(),
    display_order: z.number(),
    enabled: z.boolean(),
    computed_value: z.string().nullable(),
    computed_unit: z.string().nullable(),
    computed_status: z.string().nullable(),
    computed_error: z.unknown().nullable(),
    computed_at: z.date().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
});
export const harvestSessionKpiInitializer = z.object({
    id: harvestSessionKpiId.optional(),
    harvest_id: harvestId,
    harvest_operation_id: harvestOperationId.optional().nullable(),
    source_protocol_kpi_id: harvestProtocolKpiId.optional().nullable(),
    source_template_kpi_id: harvestOperationTemplateKpiId.optional().nullable(),
    copied_from_session_kpi_id: harvestSessionKpiId.optional().nullable(),
    code: z.string().optional().nullable(),
    name: z.string(),
    formula: z.string(),
    result_unit: z.string().optional().nullable(),
    result_display_unit: z.string().optional().nullable(),
    display_group: z.string().optional().nullable(),
    display_order: z.number().optional(),
    enabled: z.boolean().optional(),
    computed_value: z.string().optional().nullable(),
    computed_unit: z.string().optional().nullable(),
    computed_status: z.string().optional().nullable(),
    computed_error: z.unknown().optional().nullable(),
    computed_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
export const harvestSessionKpiMutator = z.object({
    id: harvestSessionKpiId.optional(),
    harvest_id: harvestId.optional(),
    harvest_operation_id: harvestOperationId.optional().nullable(),
    source_protocol_kpi_id: harvestProtocolKpiId.optional().nullable(),
    source_template_kpi_id: harvestOperationTemplateKpiId.optional().nullable(),
    copied_from_session_kpi_id: harvestSessionKpiId.optional().nullable(),
    code: z.string().optional().nullable(),
    name: z.string().optional(),
    formula: z.string().optional(),
    result_unit: z.string().optional().nullable(),
    result_display_unit: z.string().optional().nullable(),
    display_group: z.string().optional().nullable(),
    display_order: z.number().optional(),
    enabled: z.boolean().optional(),
    computed_value: z.string().optional().nullable(),
    computed_unit: z.string().optional().nullable(),
    computed_status: z.string().optional().nullable(),
    computed_error: z.unknown().optional().nullable(),
    computed_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=HarvestSessionKpi.js.map